import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { SectionLabel, Reveal } from "./Reveal";

const MEDIA = ["case-aul-v2", "case-city-v2", "case-industry-v2"];
const KB = ["kb-a", "kb-b", "kb-c"];
const OFFSETS = ["", "md:mt-24", "md:mt-12"];

const frame = {
  hidden: { clipPath: "inset(18% 12% 18% 12% round 28px)" },
  show: { clipPath: "inset(0% 0% 0% 0% round 28px)", transition: { duration: 1.4, ease: [0.16, 1, 0.3, 1] } },
};

export const UseCases = () => {
  const { t } = useLang();
  return (
    <section id="cases" className="relative py-28 md:py-40" data-testid="cases-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <SectionLabel n="03">{t.cases.label}</SectionLabel>
            <Reveal>
              <h2 className="font-display text-3xl md:text-6xl mt-8 text-[var(--text)]">{t.cases.title}</h2>
            </Reveal>
          </div>
        </div>
        <div className="mt-16 grid md:grid-cols-3 gap-10 md:gap-6">
          {t.cases.items.map((c, i) => (
            <motion.article
              key={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.15 }}
              className={`group ${OFFSETS[i]}`}
              data-testid={`case-card-${i}`}
            >
              <motion.div variants={frame} className="relative aspect-[4/5] overflow-hidden rounded-[28px]">
                <div className="w-full h-full transition-transform duration-[1.4s] ease-out group-hover:scale-105">
                  <img
                    data-testid={`case-image-${i}`}
                    loading="lazy"
                    decoding="async"
                    src={`/assets/${MEDIA[i]}.webp`}
                    alt={c.t}
                    className={`w-full h-full object-cover kenburns ${KB[i]}`}
                  />
                </div>
                <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent_45%,rgba(10,13,20,0.85))]" />
                <h3 className="absolute left-6 bottom-6 right-6 font-display text-2xl md:text-3xl text-white">{c.t}</h3>
              </motion.div>
              <p className="mt-5 text-sm md:text-base text-[var(--muted)] leading-relaxed pr-6">{c.d}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
